import $ from 'jquery'

function skipBlock () {
  $('.skip__item').each(function(){
    let item = $(this).find('.skip__item__content');
    let title = $(this).find('.skip__item__title');
    let content = $(this).find('.skip__item__content-toggle');
    title.on('click' , function(){
        item.toggleClass('active');
        content.slideToggle();
    })
  });
}

export { skipBlock }
